var map = {
	"./arms_1_2.png": "733d",
	"./arms_2_2.png": "387c",
	"./arms_3_2.png": "0263",
	"./arms_4_2.png": "f80e",
	"./arms_5_2.png": "28a3",
	"./arms_6_2.png": "3323"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fdd4";